import i18next from 'i18next';
import axios from 'axios';
import { initI18n } from '@om/i18n';

const localePath = `${import.meta.env.BASE_URL}locales/{{lng}}/{{ns}}.json`;

initI18n({
  ns: [
    'common',
    'celebrations',
    'events',
    'guests',
    'services',
    'activities',
    'goals',
    'bookings',
    'contacts',
    'profile',
  ],
  defaultNS: 'common',
  localePath,
});

// Keep X-Language header in sync with active i18next language
i18next.on('initialized', () => {
  axios.defaults.headers.common['X-Language'] = i18next.language;
});
i18next.on('languageChanged', (lng: string) => {
  axios.defaults.headers.common['X-Language'] = lng;
});

